import React from "react";
import { SelectChangeEvent } from "@mui/material";
import { Select, MenuItem, InputLabel, FormControl } from "./styles";
import GradeIcon from "@mui/icons-material/Grade";

export interface SelectItemProps {
  label: string;
  value: string;
}

export interface SelectRatingProps {
  width?: number;
  /** 상단 이름 */
  name?: string;
  /** 값 */
  value: string | number;
  /** 값이 변할때 실행될 함수 */
  selectHandler: (event: SelectChangeEvent<any>) => void;
  /** 디폴트 값 */
  defaultValue: number;
  /** 선택지 리스트 */
}

export const SelectRatingComponent = ({
  width = 200,
  name,
  value,
  selectHandler,
  defaultValue,
}: SelectRatingProps) => {
  return (
    <FormControl>
      <InputLabel id={name}>{name}</InputLabel>
      <Select
        width={width}
        labelId={name}
        id={name}
        value={value}
        onChange={selectHandler}
        defaultValue={defaultValue}
      >
        <MenuItem key={1} value={1}>
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />
        </MenuItem>
        <MenuItem key={2} value={2}>
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />{" "}
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />
        </MenuItem>
        <MenuItem key={3} value={3}>
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />{" "}
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />
        </MenuItem>
        <MenuItem key={4} value={4}>
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />{" "}
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />{" "}
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />
        </MenuItem>
        <MenuItem key={5} value={5}>
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />{" "}
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />{" "}
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />
          <GradeIcon fontSize="small" sx={{ color: "#faaf00" }} />
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default SelectRatingComponent;
